// extracted by mini-css-extract-plugin
export default {"loader_container":"referralLoader_loader_container__4ELjm"};